<template>
	<UITopHeading narrow>Passwort vergessen</UITopHeading>
	<div class="container flex flex-col items-center">
		<div class="max-w-lg">
			<div class="md:mx-8">
				<p class="mb-6 text-neutral-800">
					Bitte gib die E-Mail Adresse an, die du bei der Registrierung
					eingetragen hast. Wenn die angegebene E-Mail Adresse zu einer
					Anmeldung passt, bekommst du eine E-Mail von uns zugesendet, die
					deinen Benutzernamen enthält und du über die E-Mail ein neues Passwort
					setzen kannst.
				</p>
				<UAlert
					v-if="hasError"
					type="error"
					title="Das hat nicht geklappt!"
					icon="i-heroicons-exclamation-circle"
					description="Die E-Mail Adresse konnte nicht gefunden werden oder es ist ein Fehler bei der Übertragung aufgetreten."
					color="error"
					variant="soft"
					class="mb-6"
				/>
				<UAlert
					v-if="hasSuccess"
					type="success"
					title="E-Mail wurde erfolgreich versendet. Bitte überprüfe dein Postfach."
					icon="i-heroicons-check-circle"
					color="success"
					variant="soft"
					class="mb-6"
				/>
				<UForm
					ref="form"
					class="flex max-w-md flex-col gap-4"
					:state="state"
					:schema="schema"
					submit.prevent
				>
					<UFormField name="email" label="E-Mail Adresse">
						<UInput
							v-model="state.email"
							placeholder="E-Mail Adresse"
							icon="i-heroicons-envelope"
						/>
					</UFormField>
					<UButton
						block
						icon="i-heroicons-chevron-right"
						trailing
						class="mt-6"
						:loading="loading"
						@click="submitForgotMail"
					>
						Passwort anfordern
					</UButton>
				</UForm>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import * as Yup from 'yup'

useSeoMeta({
	title: 'Passwort vergessen',
	ogTitle: 'Passwort vergessen',
	twitterTitle: 'Passwort vergessen',
	description:
		'Wenn du dein Passwort vergessen hast, kannst du hier ein neues anfordern.',
	ogDescription:
		'Wenn du dein Passwort vergessen hast, kannst du hier ein neues anfordern.',
	twitterDescription:
		'Wenn du dein Passwort vergessen hast, kannst du hier ein neues anfordern.',
	ogUrl: 'https://propellerfestival.de/forgotpassword',
})

const userStore = useUserStore()

const loading = ref(false)
const hasError = ref(false)
const hasSuccess = ref(false)

const form = ref()
const state = ref({
	email: '',
})
const schema = Yup.object({
	email: Yup.string().required('Bitte E-Mail Adresse eingeben.'),
})

// Send the password forgot mail via the api
async function submitForgotMail() {
	hasError.value = false
	hasSuccess.value = false
	loading.value = true

	// Validate the form
	try {
		await form.value.validate()
	} catch (error) {
		console.log('validation error', error)
		loading.value = false
		return
	}

	try {
		await userStore.forgotPassword(state.value.email)

		umTrackEvent('forgot_password', {
			category: 'user',
			action: 'forgot_password',
			label: 'forgot password',
		})

		hasSuccess.value = true
	} catch (error) {
		console.log('forgot password error', error)
		hasError.value = true
	} finally {
		loading.value = false
	}
}

onUnmounted(() => {
	loading.value = false
	hasError.value = false
	hasSuccess.value = false
})
</script>

<style scoped></style>
